export const BRANDING_IMAGES_SETTINGS = {
  LOGO: {
    name: 'logo',
    label: 'Desktop Mode',
    url: './assets/img/brand/logo.png',
    type: 'png',
    mimeTypes: ['image/png', 'image/x-citrix-png', 'image/x-png'],
    size: {w: 200, h: 51}

  },
  LOGO_MOBILE: {
    name: 'logoMobile',
    label: 'Mobile Mode',
    url: './assets/img/brand/logo_mobile.png',
    type: 'png',
    mimeTypes: ['image/png', 'image/x-citrix-png', 'image/x-png'],
    size: {w: 100, h: 100}
  },
  FAV_ICON: {
    name: 'favIcon',
    label: 'Browser Icon',
    url: './favicon.ico',
    type: 'ico',
    mimeTypes: ['image/x-icon'],
    size: {w: 32, h: 32}
  }
};